<template>
	<div id="app">

		<pagehead ref="child" />

		<!-- 大图 -->
		<div class="banner pr tac">
			<!-- 大图 -->
			<img src="../assets/banner.png" >
			
			<div class="banWarp pa pmid">
				<!-- 介绍文字 -->
				<div class="banWarpTxt usn">云程科技主数据查询</div>
				<!-- 功能区 -->
				<div class="banWarpSeacher oh df w900 mt70 br10">
					<!-- 输入框 -->
					<label class="banWarpSeacherL db bw ct">
						<div class="ptb10">
							<el-input class=" f18 c666" v-model="keywords" placeholder="输入HCO名称"  @keyup.enter.native="seacher"></el-input></el-col>
						</div>
					</label>
					<!-- 按钮 -->
					<div class="banWarpSeacherR df aic f1 bffa902 cp" @click="seacher">
						<div class="w100p f18 b tac">搜索</div>
					</div>
				</div>
				<!-- 右侧高级搜索 -->
				<div class="banWarpAfter df aic pa cw cp" @click="high">
					<div class="banWarpAfterL"><img src="../assets/icon-seacher.png" ></div>
					<div class="banWarpAfterR ml10 cw f18 wsn">高级搜索</div>
				</div>
			</div>
		</div>
		
		<!-- 我们的服务 -->
		<el-container class="mySever w1k2 mt30 mauto mb40 pt35 bw">
			<el-header class="tac c333 f30 b">我们的服务</el-header>
			<el-main class="pb25">
				<ul class="df dfsa tac">
					<li>
						<div class="navImg">
							<img src="../assets/navbar-1.png">
						</div>
						<div class="navTxt mt10 c333 f20 b">数据类型</div>
					</li>
					<li>
						<div class="navImg">
							<img src="../assets/navbar-2.png">
						</div>
						<div class="navTxt mt10 c333 f20 b">查询</div>
					</li>
					<li>
						<div class="navImg">
							<img src="../assets/navbar-3.png">
						</div>
						<div class="navTxt mt10 c333 f20 b">匹配</div>
					</li>
					<li>
						<div class="navImg">
							<img src="../assets/navbar-4.png">
						</div>
						<div class="navTxt mt10 c333 f20 b">API对接</div>
					</li>
				</ul>
			</el-main>
		</el-container>

		<pagefoot />
		
	</div>
</template>
<script>
	// 全局变量
	var that;
	export default{
		
		// 页面变量
		data() {
			return {
				// 关键字
				keywords: '',
				
			}
		},
		
		// 实例化后
		created() {
			
			that = this;
			
			// 绑定事件
			window.addEventListener('keydown',this.keyDown);

		},


		//	
		activated(e){
			
			if(that.$route.query.login || !localStorage.getItem("token")){
				// that.$refs.child.loginAlert = true;
				that.$refs.child.login = false;
			}
			
		},


		// 方法集
		methods:{
			
	
			
			// 键盘按下
			keyDown(e){
				// 判断是否是回车
				if(e.keyCode == 13){
					// 执行搜索
					that.seacher();
				}
			},
			
			// 搜索
			seacher(){
				
				// 判断是否登录 （子组件的方法）
				if(!localStorage.getItem("token")){
					that.$refs.child.loginAlert = true;
					return;
				};
				
				// 判断输入框是否有值
				if(!that.keywords){
					that.$message.warning('请输入需要查询的内容');
					return ;
				};
				
				// 跳转页面
				that.$router.push({
					path: '/seacherDetails',
					query: {
						// 传值
						value: that.keywords,
					}
				});
			},
			
			// 高级搜索
			high(){
				
				// 判断是否登录 （子组件的方法）
				if(!localStorage.getItem("token")){
					that.$refs.child.loginAlert = true;
					return;
				};
				
				// 判断输入框是否有值 搜索值 or 跳转页面
				if (that.keywords){

					// 跳转页面
					that.$router.push({
						path: '/seacherDetails',
						query: {
							// 传值
							value: that.keywords,
						}
					});
					
				} else {
					
					// 跳转页面
					that.$router.push({path: '/seacherDetails'});
					
				};
			},
		},
	};
</script>
<style>
	/* 轮播图 */
	/* 轮播图上文字 */
	.banWarpTxt {
		font-weight: bold;
		font-size: 50px;
		color: #ffffffcc;
		letter-spacing: 5px;
		cursor: default;
	}
	/* 轮播图下内容 */
	.banWarpSeacher {
		box-shadow: 0px 6px 18px 3px rgba(15, 15, 15, 0.13);
	}
	/* 轮播图下左 */
	.banWarpSeacherL {
		flex: 5;
	}
	/* 轮播图下左输入框 */
	.banWarpSeacherL .el-input__inner {
		color: #666 !important;
		border: 0;
	}
	/* 轮播图下右 */
	.banWarpSeacherR {
		letter-spacing: 3px;
	}
	/* 轮播图右额外 */
	.banWarpAfter {
		bottom: 15px;
		left: calc(100% + 20px);
	}
	/* 图内图 */
	.banWarpAfterL {
		width: 16px;
		height: 16px;
	}
	
	/* 我们的服务 */
	.mySever {
		cursor: default;
	}
	/* 导航图片 */
	.mySever ul li .navImg {
		transition: .5s;
	}
	/* 经过导航图片 */
	.mySever ul li:hover .navImg {
		transform: translateY(-10px);
	}

</style>